<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PP1.w.1.0.0"></a></div>
<div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PP1.w.2.0.0"></a><a id="GBS.PP1.w.2.0.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA1"></a>
<div class="gtxt_body" id="block.2.0.0.box.392.604.876.480.q.100">
<a id="ORIG-GBS.PA1.w.0.0.0"></a><p class="gtxt_body" id="para.2.0.0.box.392.604.876.480.q.100" style="font-size:198%;text-align:center;"><a id="GBS.PP1.w.3.0.0"></a><a id="GBS.PP2"></a><a id="GBS.PP2.w.0.0.0"></a><a id="GBS.PA1"></a><a id="GBS.PA1.w.0.0.0"></a>LOUISIANA IN WORDS</p><a id="GBS.PA2"></a><a id="GBS.PA2.w.0.0.0"></a><a id="GBS.PA3"></a><a id="GBS.PA3.w.0.0.0"></a>
</div><a id="GBS.PA3.w.1.0.0"></a><a id="GBS.PA3.w.2.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA3.w.2.1.0"></a></div><div style="display:none;"><a id="GBS.PA3.w.3.0.0"></a></div><div style="display:none;"><a id="GBS.PA3.w.4.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA3.w.4.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA3.w.5.0.0"></a></div><div class="flow" style=""><a id="GBS.PA4"></a><a id="GBS.PA4.w.0.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA4.w.1.0.0"></a><a id="GBS.PA4.w.1.1.0"></a><a id="GBS.PA4.w.2.0.0"></a><a id="GBS.PA4.w.3.0.0"></a><a id="GBS.PA4.w.3.1.0"></a><a id="GBS.PA4.w.3.2.0"></a><a id="GBS.PA4.w.4.0.0"></a><a id="GBS.PA4.w.5.0.0"></a><a id="GBS.PA4.w.6.0.0"></a><a id="GBS.PA4.w.7.0.0"></a><a id="GBS.PA4.w.8.0.0"></a><a id="GBS.PA4.w.9.0.0"></a></div><div style="display:none;"><a id="GBS.PA5"></a><a id="GBS.PA5.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA5.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA5.w.0.0.0.2"></a></div><div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA3"></a>
<a id="GBS.PA5.w.0.0.0.3"></a><img alt="Image for page 4" src="data/content-0002.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PA5.w.0.0.0.4"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA4"></a>
<a id="GBS.PA5.w.0.0.0.5"></a><img alt="Image for page 5" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA5.w.0.0.0.6"></a></div>
<div style="display:none;"><a id="GBS.PA5.w.0.0.0.7"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0004.vue?25205f73